import React from 'react';

const VerResLab1 = ({autorizacUA, styles, handleClickRegr, idLista}) => {
  const a250505 = autorizacUA.findIndex( autorizac => autorizac === "250505" );
  const informe = 'INFORME LCM-LAB-' + idLista.numeroInflab + '-' + idLista.mecInflab
  const colorEstado = idLista.estado==='ALARMA'?'yellow':idLista.estado==='PELIGRO'?'red':idLista.estado==='CONFIABLE'?'green':'#FEC500'

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        {informe}
      </button>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        EMPRESA
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrEmpresa}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        PLANTA
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrPlanta}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        SECCION
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrSeccion}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        EQUIPO
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrEquipo}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        COMPONENTE
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrComponente}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        MECANISMO
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrMecanismo}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        APLICACION
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrAplicacion}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        LUBRICANTE
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.descrLubricante}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        FECHA DE MUESTRA
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.fechaMuestra}
      </p>
      <hr></hr>      
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        ESTADO
      </p>
      <p style={{background: colorEstado, color: 'white', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        {idLista.estado}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        OBSERVACIONES DEL LAB.
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.observacionesLab}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        ANALISIS
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.observaciones}
      </p>
      <hr></hr>
      <p style={{color: 'red', fontSize: '1em', fontWeight: 'bold', margin: '0em 0em 0em 1.5em'}}>
        RECOMENDACIONES
      </p>
      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em 0em 0em 1.5em'}}>
        {idLista.acciones}
      </p>
      <hr></hr>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerResLab1